var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagCn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 51,
  height: 35,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DE2910",
  d: "M0 0h51v35H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDE00",
  d: "m8.4 3.84 3.39 10.42-8.87-6.44h10.96l-8.87 6.44zM18.75 2.07l-.32 3.64-1.88-3.13 3.36 1.43-3.56.82zM23.22 6.34l-1.71 3.23-.52-3.61 2.55 2.62-3.6-.63zM23.64 12.78l-2.87 2.25 1-3.51 1.25 3.43-3.03-2.04zM18.68 15.48l-.17 3.65-2.01-3.05 3.42 1.29-3.52.97z"
})));
export default SvgFlagCn;